const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolar1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 508 508",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 254,
    cy: 254,
    r: 254
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD05B"
    },
    cx: 254,
    cy: 254,
    r: 120
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M279.6,387.2L254,446l-25.6-58.8c8.4,1.6,16.8,2.4,25.6,2.4C262.8,389.6,271.6,388.8,279.6,387.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M279.6,120.8c-8.4-1.6-16.8-2.4-25.6-2.4c-8.8,0-17.6,0.8-25.6,2.4L254,62L279.6,120.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M118.4,254c0,8.8,0.8,17.6,2.4,26L62,254l58.8-25.6C119.2,236.4,118.4,245.2,118.4,254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M387.2,280c1.6-8.4,2.4-16.8,2.4-26c0-8.8-0.8-17.6-2.4-25.6L446,254L387.2,280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M178,366.4L118,390l23.2-60C151.2,344.4,163.6,356.8,178,366.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M390,118l-23.2,60c-9.6-14.4-22-26.8-36.4-36.4L390,118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M178,141.6c-14.4,9.6-26.8,22-36.4,36.4L118,118L178,141.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M390,390l-60-23.2c14.4-9.6,26.8-22,36.4-36.4L390,390z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "297.2,248 262.4,248 273.2,182.8 210.8,260 245.6,260 234.8,325.2 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolar1);
export default __webpack_public_path__ + "static/media/solar-1.6a093e984c04c7053a26781c9d1a6d21.svg";
export { ForwardRef as ReactComponent };